import useAppStateStore from "../../store/client/appState";
import { HTTP_STATUS } from "../wv/consts";
import { transformUserAgent } from "../wv/transformUserAgent";

interface DeleteUserProps {
  token: string;
}

export async function deleteUser({ token }: DeleteUserProps): Promise<{
  result: {
    ok: boolean;
    statusText: string;
    status: number;
  } | null;
  error: { status: number; message: string } | null;
}> {
  const { userAgent } = useAppStateStore.getState();

  try {
    // api route handler(BFF)를 통해 회원 탈퇴
    const response = await fetch(`/api/auth/withdraw`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Access-Token": `Bearer ${token}`,
        "User-Agent": transformUserAgent(userAgent),
      },
    });

    if (!response.ok) {
      return {
        result: {
          ok: response.ok,
          statusText: response.statusText,
          status: response.status,
        },
        error: {
          status: response.status,
          message: `Failed to delete user, status code: ${response.status}`,
        },
      };
    }

    return {
      result: {
        ok: response.ok,
        statusText: response.statusText,
        status: response.status,
      },
      error: null,
    };
  } catch (err) {
    if (err instanceof Error) {
      return {
        result: null,
        error: {
          status: HTTP_STATUS.INTERNAL_SERVER_ERROR,
          message: `Failed to delete user, error: ${err.message}`,
        },
      };
    }
    return {
      result: null,
      error: {
        status: HTTP_STATUS.INTERNAL_SERVER_ERROR,
        message: `Failed to delete user, error: ${err}`,
      },
    };
  }
}
